import { UserSearchCard } from '@platform/client/schemas';
import { Avatar, PillBadge } from '@platform/components';

type UserCardProps = {
  user: UserSearchCard;
};

export const UserCard = (props: UserCardProps) => {
  const { firstName, lastName, languages, skills, yearsExperience, image, id, headline } =
    props.user;

  return (
    <a
      className='min-w-[378px] flex flex-col bg-white shadow-md rounded-md cursor-pointer p-6'
      href={`/platform/directory/users/${id}`}
      target='_blank'
    >
      <div className='flex flex-row gap-3'>
        <Avatar
          type='avatar'
          size='5xl'
          avatarUrl={image ?? ''}
          additionalClassNames='min-w-[113px]'
        />
        <div className='flex flex-col flex-shrink '>
          <div className='text-lg font-semibold text-gray-500'>
            {firstName} {lastName}
          </div>
          <div>{headline ?? `I am a professional with ${yearsExperience} years of experience`}</div>
        </div>
      </div>
      <div className='w-full flex flex-col justify-between gap-3 pt-4'>
        <div>Skills</div>
        <div>
          {skills.length > 0 && (
            <div className='flex flex-row gap-2 flex-wrap mb-2'>
              {skills.map((skill) => (
                <PillBadge key={skill} size='md' variant='plain' color='gray'>
                  {skill}
                </PillBadge>
              ))}
            </div>
          )}
        </div>
        <div>Speaks</div>
        <div>
          {languages.length > 0 && (
            <div className='flex flex-row gap-2 flex-wrap mb-2'>
              {languages.map((language) => (
                <PillBadge key={language} size='md' variant='plain' color='gray'>
                  {language}
                </PillBadge>
              ))}
            </div>
          )}
        </div>
      </div>
    </a>
  );
};
